import { createFileRoute } from "@tanstack/react-router";

import PackagesPage from "./-components/PackagesPage";

export const Route = createFileRoute("/_app/_dashboard/packages/$packageId")({
  component: PackagesPage,
});
